import { createIcon } from './createIcon'

export const TrashIcon = createIcon({
  displayName: 'Trash',
  viewBox: '3 1 14 17',
  path: [
    <path
      d="M11.6667 8.33333V14.1667M8.33337 8.33333V14.1667M5.00004 5V14.8333C5.00004 15.7668 5.00004 16.2331 5.1817 16.5897C5.34149 16.9033 5.59627 17.1587 5.90987 17.3185C6.26604 17.5 6.73254 17.5 7.66413 17.5H12.3359C13.2675 17.5 13.7334 17.5 14.0895 17.3185C14.4031 17.1587 14.6588 16.9033 14.8186 16.5897C15 16.2335 15 15.7675 15 14.8359V5M5.00004 5H6.66671M5.00004 5H3.33337M6.66671 5H13.3334M6.66671 5C6.66671 4.22343 6.66671 3.83534 6.79357 3.52905C6.96273 3.12067 7.28697 2.79602 7.69535 2.62687C8.00164 2.5 8.39014 2.5 9.16671 2.5H10.8334C11.6099 2.5 11.9982 2.5 12.3045 2.62687C12.7129 2.79602 13.0373 3.12067 13.2064 3.52905C13.3333 3.83534 13.3334 4.22343 13.3334 5M13.3334 5H15M15 5H16.6667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
  ],
})
